import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { getFile } from '@/utils/fileOperations';

/**
 * Async thunk for retrieving a file from Helia/IPFS
 */
export const getFileFromHelia = createAppAsyncThunk(
  'helia/getFile',
  async(
    { sixId, cid, onProgress }: {
      sixId: string;
      cid: string;
      onProgress?: (loaded: number, total: number) => void;
    },
    { extra: { pocServices }, rejectWithValue }
  ) => {
    try {
      const helia = pocServices.p2pStackManagerService.getHeliaNode(sixId);
      if(helia === null) {
        throw new Error('Helia node is not initialized');
      }
      const data = await getFile(helia, cid, onProgress);
      return { cid, data };
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error getting file';
      return rejectWithValue(errorMessage);
    }
  }
);
